var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:_vm.currentTheme},[_c('li',[_c('button',{class:{'active': 'pt' === _vm.$i18n.locale},on:{"click":function($event){return _vm.changeLang('pt')}}},[_vm._v("PT")])]),_c('li',[_c('button',{class:{'active': 'en' === _vm.$i18n.locale},on:{"click":function($event){return _vm.changeLang('en')}}},[_vm._v("EN")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }